import { ClickAwayListener, Popper } from '@mui/material';
import React, { useRef, useState } from 'react';

import { ButtonContainer, StyledPopperPaper } from './styledComponents';

const TooltipDataGrid = ({ renderContent, renderTrigger, iconPath = null }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <>
      <div ref={anchorRef}>
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          {renderTrigger ? (
            renderTrigger({ toggleOpen: () => setOpen((open) => !open) })
          ) : (
            <ButtonContainer isOpened={open} onClick={() => setOpen((open) => !open)}>
              <img
                alt="tooltip"
                src={iconPath || `/images/inpulse/list-${!open ? 'black' : 'white'}-small.svg`}
              />
            </ButtonContainer>
          )}
        </ClickAwayListener>
      </div>

      <Popper
        anchorEl={anchorRef.current}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              altAxis: false,
              padding: 8,
            },
          },
        ]}
        open={open}
        placement="right-start"
      >
        <StyledPopperPaper>{renderContent()}</StyledPopperPaper>
      </Popper>
    </>
  );
};

export default TooltipDataGrid;
